import { Tooltip } from 'antd';
import cn from 'classnames';

import { useOverflowTooltip } from '@app/shared/components/OverflowTooltip';

import type { FC } from 'react';

import '../styles/TruncatedHeaderText.scss';

type TruncatedHeaderTextLineCount = 1 | 2 | 3;

// Подсказка — это превью, а не полотно текста. Длинное сообщение лида
// разрастало попап за пределы экрана, он накрывал сам триггер, из-за чего
// pointerleave/pointerenter гоняли тултип по кругу (моргание).
// Ограничиваем текст и ширину попапа (`__tooltip` в SCSS).
const MAX_TOOLTIP_TEXT_LENGTH = 300;
const ELLIPSIS = '…';

const getTooltipText = (text: string): string =>
  text.length > MAX_TOOLTIP_TEXT_LENGTH
    ? `${text.slice(0, MAX_TOOLTIP_TEXT_LENGTH).trimEnd()}${ELLIPSIS}`
    : text;

interface TruncatedHeaderTextProps {
  className?: string;
  lineCount: TruncatedHeaderTextLineCount;
  text?: string;
  testId?: string;
}

export const TruncatedHeaderText: FC<TruncatedHeaderTextProps> = ({
  className,
  lineCount,
  text = '',
  testId,
}) => {
  const { isOpen, contentRef, openHandler, closeHandler } =
    useOverflowTooltip();

  const content = (
    <span
      ref={contentRef}
      className={cn(
        'TruncatedHeaderText',
        `TruncatedHeaderText--lines-${lineCount}`,
        className
      )}
      data-testid={testId}
      onPointerEnter={openHandler}
      onPointerLeave={closeHandler}
      onFocus={openHandler}
      onBlur={closeHandler}
    >
      {text}
    </span>
  );

  // The antd Tooltip mounts only after hovering/focusing a span that is
  // actually truncated. Initial list/table render mounts a plain <span> per
  // cell — no per-cell Tooltip, ResizeObserver, or layout measurement — and the
  // controlled lifecycle (close on leave/blur/scroll/unmount) keeps the popup
  // from sticking while the table scrolls or a virtualized row unmounts.
  if (!isOpen) {
    return content;
  }

  return (
    <Tooltip
      open
      title={getTooltipText(text)}
      destroyOnHidden
      classNames={{ body: 'TruncatedHeaderText__tooltip' }}
    >
      {content}
    </Tooltip>
  );
};
